interface TextAreaGroupProps {
	label: string;
	value: string;
	onChange: (v: string) => void;
	placeholder?: string;
}

export const TextAreaGroup = ({
	label,
	value,
	onChange,
	placeholder,
}: TextAreaGroupProps) => (
	<div className="form-group">
		<label htmlFor={label} className="form-label">
			{label}
		</label>
		<textarea
			id={label}
			value={value}
			onChange={(e) => onChange(e.target.value)}
			placeholder={placeholder}
			rows={4}
			className="form-control textarea-control"
		/>
	</div>
);
